export default __webpack_public_path__ + "static/media/bot-icon.374d8938.svg";